module.exports = __webpack_public_path__ + "media/images/athletes/1404-00aea8a3161b378fafb31feb1dc9afa2.png";